import { Ref } from "react";

import { RequiredAsterisk } from "../common";
import { DDQForm, FormConfig } from "../types";
import FormSection, { Mode } from "./FormSection";

export type Props = {
  register?: () => Ref<any>;
  mode: Mode;
  form: DDQForm;
};

export default function RegulatorFormSection({ register, mode, form }: Props) {
  const formConfig: FormConfig = {
    regulatorName: {
      type: "text",
      label: (
        <span>
          3A. Name of the entity&apos;s primary financial regulator / supervisory authority
          {RequiredAsterisk}
        </span>
      ),
    },
    jurisdictionsGrantedLicenses: {
      type: "text",
      label: (
        <span>
          3B. Please provide a list of national jurisdictions, other than your primary national jurisdiction, where you
          have been granted licenses or other approvals or have registered as required to operate, and the name of the
          regulator / supervisory authority{RequiredAsterisk}
        </span>
      ),
    },
    entityLicenseNumber: {
      type: "text",
      label: (
        <span>
          3C. Entity&apos;s license / registration number(s) for each jurisdiction it operates in
          {RequiredAsterisk}
        </span>
      ),
    },
    entityPermitted: {
      type: "boolean",
      label: (
        <span>
          3D. Is the entity permitted to send and/or receive transfers of virtual assets in the jurisdictions in which
          it operates?{RequiredAsterisk}
        </span>
      ),
    },
  };

  return (
    <FormSection
      title="Section 3. Regulator & licensing"
      formConfig={formConfig}
      register={register}
      mode={mode}
      form={form}
    />
  );
}
